<template>
    <div>
        <div class="header">
            <div class="back" @click="back()">
                <span class="icon-dropdown_up"></span>
                indietro
            </div>
            <div class="sf2__title--left-stroke title--xs">Vediamo <strong>i consumi</strong></div>
        </div>
        
        <p>Inserisci i tuoi consumi totali annui: li puoi trovare in ogni bolletta. Se vuoi, puoi indicarli anche solo per il Gas o per la Luce.</p>
 
        <div class="form-row">
            <div class="form-label">Luce – Consumo annuo</div>
            <input class="unit" type="text" name="consumo-luce" placeholder="Scrivi qui il consumo" maxlength="4" v-model="light" @keypress="isNumber($event)"> kWh
            <div class="autoFill" @click="openLight = true">Guarda valori medi di esempio</div>
            <div class="popFill" v-if="openLight == true" v-on:mouseleave="openLight = false">
                <table>
                    <tr>
                        <th><strong>Famiglia</strong></th>
                        <th><strong>Consumo</strong></th>
                    </tr>
                    <tr @click="setLight(1200)">
                        <td><strong>1</strong>/<strong>2</strong> persone</td>
                        <td><strong>1200</strong> kWh</td>
                    </tr>
                    <tr @click="setLight(2700)">
                        <td><strong>2</strong>/<strong>3</strong> persone</td>
                        <td><strong>2700</strong> kWh</td>
                    </tr>
                    <tr @click="setLight(3500)">
                        <td><strong>3</strong>/<strong>4</strong> persone</td>
                        <td><strong>3500</strong> kWh</td>
                    </tr>
                </table>
            </div>
        </div>

        <div class="form-row">
            <div class="form-label">Gas – Consumo annuo</div>
            <input class="unit" type="text" name="consumo-gas" placeholder="Scrivi qui il consumo" maxlength="4" v-model="gas" @keypress="isNumber($event)"> Smc
            <div class="autoFill" @click="openGas = true">Guarda valori medi di esempio</div>
            <div class="popFill" v-if="openGas == true" v-on:mouseleave="openGas = false">
                <table>
                    <tr>
                        <th><strong>Famiglia</strong></th>
                        <th><strong>Consumo</strong></th>
                    </tr>
                    <tr @click="setGas(110)">
                        <td>solo <strong>cucinare</strong></td>
                        <td><strong>110</strong> Smc</td>
                    </tr>
                    <tr @click="setGas(350)">
                        <td><strong>cucinare</strong> più <strong>acqua calda</strong></td>
                        <td><strong>350</strong> Smc</td>
                    </tr>
                    <tr @click="setGas(1516)">
                        <td>anche per <strong>riscaldamento</strong></td>
                        <td><strong>1516</strong> Smc</td>
                    </tr>
                </table>
            </div>
        </div>
        
        <div class="lock-down">
            <button class="sf2-btn" @click="next()" :disabled=" !( gas > 0 || light > 0 )">Continua</button>
        </div>
    </div>
</template>

<script>

    export default {
        name: "Consumption",
        components: {
        },
        props: {
        },
        data() {
            return {
                light: '',
                gas: '',
                openLight: false,
                openGas: false
            };
        },
        mounted() {
            console.log('Consumption mounted');
        },
        computed: {

        },
        methods: {
            setLight( v ) {
                this.light = v; 
                this.openLight = false; 
            },

            setGas( v ) {
                this.gas = v; 
                this.openGas = false; 
            },

            next() {
                console.log( 'Consumption emit onNext' );
                console.log( 'Consumption emit onNext ' + this.gas + ' - ' + this.light )
                console.log( 'Consumption emit onNext ' + (this.gas > 0) + ' - ' + (this.light > 0) )

                this.$emit( 'onNext', {
                    'gas': this.gas, 
                    'light': this.light
                } );
            },

            isNumber: function(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },

            back() {
                console.log( 'Consumption emit onBack' );

                this.$emit( 'onBack', 1 );
            }
        },
    };
</script>

<style scoped lang="scss">
    
    [sf-versione="2.0"][sf-component="configuratore"] {
        .sf2__title--left-stroke { margin-bottom: 30px; line-height: 50px; }
    }
    
    .autoFill {
        text-decoration: underline; margin-top: 5px; cursor: pointer;
    }

    .popFill {
        background: #333; color: #fff; font-size: 12px; position: absolute; bottom: 30px; border-radius: 2px; left: 0;
        padding: 15px;

        &:after {
            position: absolute; bottom: -13px; content: ''; left: 50%; transform: translateX(-50%);
            width: 0; 
            height: 0; 
            border-left: 13px solid transparent;
            border-right: 13px solid transparent;
            
            border-top: 13px solid #333;
        }

        table { width: 175px;
            tr {
                td, th {
                    text-align: left;
                    &:last-child { text-align: right; }
                }
            }
            tr {
                td { padding: 15px 0 0; cursor: pointer;
                    &:last-child { text-decoration: underline; }
                }
            }
        }
    }

    button {margin-top: 30px;}

</style>